import { createListenerMiddleware } from '@reduxjs/toolkit';
import { creatorActions } from '../slices/creatorSlice';
import { RootState, AppDispatch } from '..';
import { getCreatorAtributes } from '@/utils/creatorUtilities';
import { UUID } from '@/types/types';
import ProductTypeVariantApi from '@/api/ProductTypeVariantApi';

export const creatorListenerMiddleware = createListenerMiddleware();

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.selectProductType,
	effect: async ({ payload }, listenerApi) => {
		const availableProductTypeVariants =
			await ProductTypeVariantApi.getAllByProductTypeId(payload.id);
		const creatorAttributes = getCreatorAtributes(availableProductTypeVariants);

		const selectedValues = creatorAttributes.reduce<Record<UUID, null>>(
			(acc, attribute) => {
				return {
					...acc,
					[attribute.id]: null,
				};
			},
			{}
		);

		const selectedAttributeValues = Array.from(
			{ length: payload.circulationsQuantity },
			() => ({ ...selectedValues })
		);

		listenerApi.dispatch(
			creatorActions.updateCreator({
				creatorAttributes,
				selectedAttributeValues,
				availableProductTypeVariants,
			})
		);
	},
});

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.selectAttributeValue,
	effect: async ({ payload }, listenerApi) => {},
});
